import { Text } from '@chakra-ui/react';
import type { Msg } from '@halo/chat-sdk-react';
import { tools } from '@halo/ui-chat-react';
import { MyTrans } from '@halo/ui-react';
import { MsgUserText } from '../../msg-parts';

export interface MsgExpireDurationContentProps {
  message: Msg;
}

export const MsgExpireDurationContent = memo(function MsgExpireDurationContent({
  message,
}: MsgExpireDurationContentProps) {
  const { user_name, expire_duration, user_id } = message.payload;
  const durationLabel = useMemo(
    () => tools.expireTimeOptions.find((option) => option.value == +expire_duration)?.label,
    [expire_duration]
  );

  return (
    <>
      <MyTrans
        i18nKey="chat.setTheSelfDestructTimerTo"
        components={{
          actionUser: <MsgUserText userName={user_name} userId={user_id} />,
          action: <Text as="span" color="fg.muted" />,
        }}
      ></MyTrans>
      <Text as="span" color="fg.muted">
        {durationLabel}
      </Text>
    </>
  );
});
